<!-- -->
<template>
  <div :class="{ baidu_search: true, mm: isMobile }">
    <div class="box">
      <div class="title-box">
        <div class="title">百度搜索</div>
        <div class="type">客户主动搜索关键词，广告高效且信任感强</div>
      </div>
      <div class="description">
        百度搜索推广是一种按效果付费的网络推广方式，是百度推广的一部分。每天网民在百度进行数亿次的搜索，其中一部分搜索词明确的表达了某种商业意图，即希望购买某一产品，寻找提供某一服务的提供商，或希望了解该产品/服务相关的信息。同时，提供这些产品/服务的企业也在寻找潜在客户。<br />通过百度搜索推广的关键词定位技术，可以将高价值的企业推广结果精准地展现给有商业意图的搜索网民，同时满足网民的搜索需求和企业的推广需求。
      </div>
      <div class="float">
        <img
          src="http://gxbg.pangodso.com/file/search_img1.png"
          alt=""
          class="center"
        />
        <div class="out" style="left: -60%; top: 40px">
          <img
            src="http://gxbg.pangodso.com/file/search_icon1.png"
            alt=""
            class="icon"
          />
          <div class="text">
            <div class="title">AI智能需求匹配</div>
            <div class="desc">精准触达，用户主动需求表达<br />更懂用户意图</div>
          </div>
        </div>
        <div class="out" style="right: -60%; top: 40px">
          <img
            src="http://gxbg.pangodso.com/file/search_icon2.png"
            alt=""
            class="icon"
          />
          <div class="text">
            <div class="title">关键词搜索</div>
            <div class="desc">通过关键词触发展现广告<br />精准触达客户</div>
          </div>
        </div>
        <div class="out" style="left: -60%; bottom: 140px">
          <img
            src="http://gxbg.pangodso.com/file/search_icon3.png"
            alt=""
            class="icon"
          />
          <div class="text">
            <div class="title">专属平台流量</div>
            <div class="desc">基于中文搜索引擎百度搜索</div>
          </div>
        </div>
        <div class="out" style="right: -67%; bottom: 140px">
          <img
            src="http://gxbg.pangodso.com/file/search_icon4.png"
            alt=""
            class="icon"
          />
          <div class="text">
            <div class="title">为品牌赋能</div>
            <div class="desc">
              广告内容深度触达<br />提升品牌曝光度和品牌美誉度
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="title-box">
        <div class="title">广告展现形式</div>
        <div class="type">在搜索结果的显著位置，优先展示您的推广信息</div>
      </div>
      <div class="content">
        <div class="types">
          <div
            :class="{ type: true, active: activeType == 0 }"
            @mouseenter="changeType(0)"
          >
            WISE样式
          </div>
          <div
            :class="{ type: true, active: activeType == 1 }"
            @mouseenter="changeType(1)"
          >
            PC样式
          </div>
        </div>
        <div class="desc">
          <div
            class="desc_content"
            style="max-width: 80%; flex-direction: column"
            v-show="activeType == 1"
          >
            <div class="item standard">
              <img src="http://gxbg.pangodso.com/file/search_img4.png" alt="" />
              <div class="title">标准推广</div>
              <div class="sub">
                操作简单、效果快速，<br />支持多个显著位置展现按点击收费，展示免费
              </div>
            </div>
            <div class="item" style="margin-left: 0; margin-top: 50px">
              <img src="http://gxbg.pangodso.com/file/search_img5.png" alt="" />
              <div class="title">高级推广</div>
              <div class="sub">
                一图胜千言，图文更具吸引力;<br />
                图片智能匹配，推广效果更佳
              </div>
            </div>
          </div>
          <div
            class="desc_content"
            style="max-width: 80%"
            v-show="activeType == 0"
          >
            <div class="item">
              <img src="http://gxbg.pangodso.com/file/search_img2.png" alt="" />
              <div class="title">标准推广</div>
              <div class="sub">
                操作简单、效果快速，支持多个显著位置展现按点击收费，展示免费
              </div>
            </div>
            <div class="item">
              <img src="http://gxbg.pangodso.com/file/search_img3.png" alt="" />
              <div class="title">高级推广</div>
              <div class="sub">
                一图胜千言，图文更具吸引力;<br />
                图片智能匹配，推广效果更佳
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
export default {
  data() {
    return {
      activeType: 1,
    };
  },
  computed: {
    ...mapState(Store, ["isMobile"]),
  },
  methods: {
    changeType(type) {
      this.activeType = type;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.box {
  margin-top: 100px;
}
.title-box {
  text-align: center;

  .title {
    color: #0d0d0d;
    font-weight: bold;
    font-size: 30px;
    letter-spacing: 1px;
  }
  .type {
    color: #6e7685;
    letter-spacing: 6px;
    margin-top: 30px;
  }
}
.description {
  width: 1200px;
  font-size: 15px;
  margin: 40px auto 0;
  letter-spacing: 2px;
  line-height: 30px;

  br {
    display: none;
  }
}
.float {
  width: fit-content;
  position: relative;
  margin: 50px auto 0;

  .center {
    width: 600px;
  }
  .out {
    position: absolute;
    display: flex;
    align-items: flex-start;

    .icon {
      width: 73px;
    }
    .text {
      margin-left: 15px;
      margin-top: 10px;

      .title {
        font-size: 20px;
        font-weight: bold;
      }
      .desc {
        margin-top: 5px;
        color: #6e7685;
        line-height: 25px;
        letter-spacing: 2px;
      }
    }
  }
}
.box2 {
  background-color: #f5f7fa;
  padding: 80px 0 100px;

  .content {
    width: 1200px;
    margin: 90px auto 0;
    display: flex;

    .types {
      .type {
        width: 250px;
        height: 70px;
        border: 1px solid #eaecee;
        font-size: 25px;
        font-weight: bold;
        text-align: center;
        line-height: 70px;
        cursor: pointer;
        position: relative;

        &:hover {
          color: $theme;

          &::after {
            display: block;
          }
        }

        &::after {
          content: "";
          display: none;
          width: 0;
          height: 0;
          border-width: 8px;
          border-style: solid;
          border-color: transparent transparent transparent #5f84de;
          position: absolute;
          right: -30px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .active {
        color: $theme;
        background-color: #eaecee;
        box-shadow: 0 16px 16px rgba($color: $theme, $alpha: 0.11);

        &::after {
          display: block;
        }
      }
    }

    .desc {
      flex-grow: 1;
      margin-left: 100px;

      .desc_content {
        display: flex;
        animation: fadeIn 0.5s linear;

        .item {
          flex: 1;
          text-align: center;

          & + .item {
            margin-left: 50px;
          }
          img {
            max-width: 100%;
          }
          .title {
            font-size: 25px;
            margin-top: 50px;
          }
          .sub {
            width: 350px;
            margin: 0 auto;
            color: #6e7685;
            line-height: 26px;
            margin-top: 25px;
          }
        }
        .standard .sub br {
          display: none;
        }
      }
    }
  }
}

.mm {
  .box {
    margin-top: 60px;
  }
  .title-box {
    .title {
      font-size: 22px;
    }
    .type {
      padding: 0 10px;
      font-size: 15px;
      margin-top: 10px;
      letter-spacing: 1px;
    }
  }
  .description {
    width: 100%;
    padding: 0 10px;
    line-height: 1.5;
    box-sizing: border-box;
    font-size: 14px;
    text-align: justify;
    letter-spacing: 1px;

    br {
      display: block;
    }
  }
  .float {
    width: 100%;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .center {
      width: 80%;
    }
    .out {
      width: 50%;
      margin-bottom: 10px;
      position: static;
      flex-direction: column;
      align-items: center;

      .icon {
        width: 50px;
      }
      .text {
        margin-left: 0;

        .title {
          font-size: 16px;
        }
        .desc {
          font-size: 12px;
          line-height: 1.5;
        }
      }
    }
  }
  .box2 {
    padding-bottom: 40px;

    .content {
      width: 100%;
      margin-top: 40px;
      flex-direction: column;

      .types {
        display: flex;

        .type {
          height: 50px;
          line-height: 50px;
          flex: 1;
          width: unset;
          font-size: 18px;
        }
        .active::after {
          top: unset;
          left: 50%;
          bottom: -30px;
          transform: translateX(-50%) rotate(90deg);
        }
      }
      .desc {
        margin-left: 0;
        margin-top: 60px;

        .desc_content {
          width: 100%;
          padding: 0 10px;
          box-sizing: border-box;
          max-width: 100% !important;

          &:first-child {
            .item + .item {
              margin-left: 0 !important;
            }
          }
          .item {
            & + .item {
              margin-left: 10px !important;
            }
            .title {
              font-size: 18px;
              margin-top: 20px;
            }
            .sub {
              width: auto;
              margin-top: 10px;
            }
          }
          .standard .sub br {
            display: block;
          }
        }
      }
    }
  }
}

@media (max-width: 1400px) {
  .float .center {
    width: 500px;
  }
  .float .out .text .desc {
    font-size: 14px;
  }
  .description {
    width: 1000px;
  }
  .box2 .content {
    width: 1000px;

    .types .type {
      width: 200px;
      font-size: 20px;
    }
    .desc .desc_content .item {
      .title {
        font-size: 20px;
      }
      .sub {
        font-size: 14px;
      }
    }
  }
}
</style>
